import React from 'react';
import styled from 'styled-components';
import { Dropdown, MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import ReactAvatar from 'react-avatar';
import { useAuth } from '../context/AuthContext';
import { useCurrentUserProfile } from '../hooks/useCurrentUserProfile';
// react-icons types are not yet compatible with React 19 typings – cast to any for now
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { FiMenu as FiMenuRaw} from 'react-icons/fi';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FiMenu: any = FiMenuRaw;
// eslint-disable-next-line @typescript-eslint/no-explicit-any


type HeaderBarProps = {
  onMenuToggle?: () => void;
  isMenuOpen?: boolean;
};

const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  height: 60px;
  background: var(--bg);
  border-bottom: 1px solid var(--outline);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const TitlePlaceholder = styled.div``;

const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

/** Shared with Layout sidebar header when the nav drawer is open. */
export const MenuToggleButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid var(--outline);
  background: var(--surface);
  color: var(--text);
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background: var(--surfaceVariant);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(1px);
  }
`;

const HeaderBar: React.FC<HeaderBarProps> = ({ onMenuToggle, isMenuOpen }) => {
  const { user, signOut } = useAuth();
  const { data: profile } = useCurrentUserProfile(user?.id);
  const navigate = useNavigate();

  if (!user) return null;

  const items: MenuProps['items'] = [
    {
      key: 'profile',
      label: 'My Profile',
      onClick: () => navigate('/profile'),
    },
    {
      key: 'logout',
      label: 'Logout',
      onClick: () => signOut(),
    },
  ];

  return (
    <Container>
      <LeftGroup>
        {onMenuToggle && !isMenuOpen && (
          <MenuToggleButton
            type="button"
            onClick={onMenuToggle}
            aria-label="Open navigation menu"
          >
            <FiMenu size={22} />
          </MenuToggleButton>
        )}
        <TitlePlaceholder />
      </LeftGroup>
      <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
        <div style={{ cursor: 'pointer' }}>
          {/* Using react-avatar for consistency across the app */}
          <ReactAvatar
            name={profile?.full_name || user.user_metadata?.full_name || user.email || 'User'}
            src={profile?.avatar || user.user_metadata?.avatar_url}
            size="36"
            round
          />
        </div>
      </Dropdown>
    </Container>
  );
};

export default HeaderBar;
